import {
  ActivitySpinnerSize,
  ActivitySpinnerWidget, ButtonProps, ButtonType, DialogFooterButtonsWidget,
  DialogPositioningBehavior,
  DialogType
} from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';

import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import {
  centerPosition,
  emailValue,
  headerStyle,
  tableStyle, textStyle,
  valueStyle
} from '~src/userManagement/components/SiteAdminDialogStyles';
import { GetSiteAdmins } from '~src/userManagement/resources/GetSiteAdmins';

interface ISiteAdminUser {
  displayName: string;
  userEmail: string;
}

export interface SiteAdminDialogContentState {
readonly siteAdmins: ISiteAdminUser[];
}

export interface SiteAdminDialogStateToProps {
  readonly siteName: string;
}

export class SiteAdminDialogContents extends React.Component<SiteAdminDialogStateToProps, SiteAdminDialogContentState> {
  constructor(props: any){
    super(props);
    this.state = {
      siteAdmins: undefined
    };
  }

  componentDidMount() {
    this.getSiteAdmins();
  }

  private getSiteAdmins(){
    GetSiteAdmins.getSiteAdmins().then((result) => {
      if (result.errors.length === 0) {
        const siteAdmins: ISiteAdminUser[] = result.items.map(siteUser => {
          return {
            displayName: siteUser.displayName,
            userEmail: siteUser.username
          };
        });
      this.setState({siteAdmins});
      } else {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: Messages.unexpectedError()
        });
      }
    });
  }

  private renderTableData() {
    return (
      <>
        <span style={textStyle}>
          {
            Messages.siteAdministratorDialogContent({
              SITE_NAME: this.props.siteName
            })
          }
        </span>
        <table style={tableStyle}>
          <tr>
            <td style={headerStyle} data-tb-test-id={'site-admin-dialog-name-header'}>
              {Messages.name()}
            </td>
            <td style={headerStyle} data-tb-test-id={'site-admin-dialog-email-header'}>
              {Messages.emailAddress()}
            </td>
          </tr>
          {this.state.siteAdmins.map(siteAdmin => (
            <tbody data-tb-test-id={'site-admin-dialog'} key={siteAdmin.userEmail}>
            <tr>
              <td style={valueStyle}>
                {siteAdmin.displayName}
              </td>
              <td style={valueStyle}>
                <a
                  data-tb-test-id={'site-admin-email'}
                  href={`mailto:${siteAdmin.userEmail}`}
                  style={emailValue}
                >
                  {siteAdmin.userEmail}
                </a>
              </td>
            </tr>
            </tbody>
          ))}
        </table>
      </>
    );
  }

  private renderSpinner() {
    return (
      <div className={centerPosition}>
        <ActivitySpinnerWidget
          testId={'site-admin-dialog-spinner'}
          spinnerSize={ActivitySpinnerSize.Large}
        />
      </div>
    );
  }

  public render(): JSX.Element {
    return this.state.siteAdmins ? this.renderTableData() : this.renderSpinner();
  }
}

const mapStateToProps: MapStateToProps<SiteAdminDialogStateToProps> = (state: AppState) => ({
  siteName: SessionSiteSelectors.siteName(state)
});

export const ConnectedSiteAdminDialogContents = connect(mapStateToProps, null)(SiteAdminDialogContents);

export interface SiteAdminDialogOwnProps {
  readonly dismiss: () => void;
}

function SiteAdminDialogFooter(props: SiteAdminDialogOwnProps) {
  const CloseButtonProps: ButtonProps = {
    buttonType: ButtonType.Outline,
    handleClick: props.dismiss,
    testId: 'site-admin-dialog-close-button',
    children: Messages.close()
  };

  return <DialogFooterButtonsWidget buttons={[ CloseButtonProps ]} />;
}

export function getSiteAdmins() {
  let modalInstance: ModalInstance;

  modalInstance= ReactModalService.open({
    shouldReturnFocusOnClose: true,
    type: DialogType.NormalWithTitleBar,
    title: Messages.contactTableauAdmin(),
    dialogContent: <ConnectedSiteAdminDialogContents />,
    showCloseButton: true,
    dismissDialogOnCloseAction: true,
    positioningBehavior: DialogPositioningBehavior.Draggable,
    dialogWidth:TabDialogWidth.width700px,
    footerContent: SiteAdminDialogFooter({
      dismiss: () => modalInstance && modalInstance.dismiss()
    }),
  });
}
